__webpack_require__.p = "https://cdn.sheetgo.com/webapp/prod/prod.2.6.38-penguin-mafia-update-IV/";